import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import './toolSeoSections.css';

function ToolSeoSections({
  toolName,
  description,
  featuresTitle,
  features = [],
  howItWorksTitle,
  howItWorksSteps = [],
  relatedTools = [],
  compact = true,
}) {
  return (
    <section className="tool-seo-shell">
      <section
        className={`tool-seo${compact ? ' tool-seo--compact' : ''}`}
        aria-label={`${toolName} information`}
      >
        <section
          className="tool-seo__section tool-seo__card"
          aria-labelledby="tool-seo-features"
          aria-describedby={description ? 'tool-seo-features-description' : undefined}
        >
        <div className="tool-seo__block fp-grid-section">
          <h2 id="tool-seo-features" className="fp-section-heading">
            {featuresTitle}
          </h2>
          {description ? (
            <p id="tool-seo-features-description" className="tool-seo__text">
              {description}
            </p>
          ) : null}
          <div className="features-grid">
            {features.map((feature) => (
              <article key={feature} className="feature-card fp-feature-card">
                <span className="feature-card-icon-badge">
                  <CheckCircle2
                    size={20}
                    strokeWidth={1.8}
                    className="fp-lucide-icon"
                    aria-hidden="true"
                  />
                </span>
                <div className="feature-card-body">
                  <p className="feature-card-title">{feature}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <section className="tool-seo__block" aria-labelledby="tool-seo-how-it-works">
          <h2 id="tool-seo-how-it-works" className="tool-seo__heading">
            {howItWorksTitle}
          </h2>
          <ul className="tool-seo__list">
            {howItWorksSteps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        </section>

        {relatedTools.length > 0 ? (
          <section className="tool-seo__block tool-seo__related" aria-labelledby="tool-seo-related">
            <h2 id="tool-seo-related" className="tool-seo__heading">
              Related AI Tools
            </h2>
            <p className="tool-seo__text">
              Explore more MyRoomsAI tools that help turn photos and floor plans into design previews.
            </p>
            <ul className="tool-seo__related-list">
              {relatedTools.map((tool) => (
                <li key={tool.path}>
                  <Link to={tool.path} className="btn btn-ghost tool-seo__related-link">
                    {tool.label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ) : null}
        </section>
      </section>
    </section>
  );
}

export default ToolSeoSections;
